import React, { useEffect, useState } from "react";
import { useForm } from "../../../../../components/forms/Form";
import PopUp from "../../../../../components/layouts/PopUp";
import { validateMinutes, validateTime, validateHours } from "../../../../businessFunctions/validations";
import { useScheduler } from "../../schedulerContext";
import styles from "./TriggerPopups.module.css"
import CloseIcon from '@mui/icons-material/Close';
import { SchedulerActions } from "../../scheduler.action";
import { useAppContext } from "../../../../../components/activity/AppContext";
import { generateUuid } from "../../../../../common";
import { v4 as uuidv4 } from 'uuid';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';





export const TriggerPopups = ({ show, handleClose }) => {

    const app = useAppContext();
    const [value, setValue] = useState([generateUuid()])


    const { setParameter, setFinalStep, setEdit, triggerEdit, setTriggerEdit, setOption, draft, timeBasedSchedulerForm,
        params, createScheduler, setCreateScheduler, setDraft, edit, paramObject, parameters, freq, setFreq } = useScheduler();



    const [data, setData] = useState({})
    const [count, setCount] = useState(0)
    const [freqs, setFreqs] = useState(freq[0].times ? freq : [
        {
            id: uuidv4(),
            day: "1",
            drp: "hours",
            hr: "",
            isOpended: false,
            min: "",
            times: "",
            week: "Monday"
        }
    ])
    const [showError, setShowError] = useState(false);

    const time = ["hours", "minutes", "days", "weeks", "months"]
    const weeks = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
    const days = Array.from({ length: 31 }, (_, i) => ({
        id: String(i + 1),
        value: i + 1
        }));

const getDayLabel = (day) => {
  const j = day % 10, k = day % 100;
  if (j === 1 && k !== 11) return `${day}st`;
  if (j === 2 && k !== 12) return `${day}nd`;
  if (j === 3 && k !== 13) return `${day}rd`;
  return `${day}th`;
};


const validateFreqs = () => {
  for (let el of freqs) {
    if (el.times === "" || el.times === null || el.times === undefined || Number(el.times) < 0) {
      return false;
    }

    if (["days", "weeks", "months"].includes(el.drp)) {
      if (
        el.hr === "" || el.hr === null || el.hr === undefined || Number(el.hr) < 0 ||
        el.min === "" || el.min === null || el.min === undefined || Number(el.min) < 0
      ) {
        return false;
      }
    }
  }
  return true;
};


    const onWatch = (errors, data) => {

    }

    const onSubmit = async (values, errors) => {
        if (!validateFreqs()) {
                // setCount((p) => p + 1);
                setShowError(true); 
                return; 
            }
        
        if (draft) {
            // setFreq([...freq.slice(1), { ...freqObj, times: values.time, drp: values.type }])

            const payload = {
                bosname: params.serviceId,
                description: timeBasedSchedulerForm.description,
                eventId: null,
                freq: freq,
                isEnabled: 2,
                isTimeBased: true,
                name: timeBasedSchedulerForm.name,
                parameters: JSON.stringify(parameters),
                projectComponentId: params.projectComponentId,
                runAsUser: params.runAsUser,
                serviceName: params.projectName+"."+params.bosName,
                serviceType: timeBasedSchedulerForm.serviceType
            }

    
            CreateScheduler(payload)
            handleClose()
            setTimeout(() => setCreateScheduler(!createScheduler), 1000)
            setDraft(false)
        }
        else if (edit) {
            handleCancel()
        }
        else {
            if (freq[freq.length - 1].times) {
                handleNext();
            }

        }

    }

    const { Form, Label, Input, Error, Select } = useForm(data, onSubmit, onWatch);




    const handleBack = () => {
        handleClose()
        setParameter(true)
    }

    const handleNext = () => {
        handleClose()
        setEdit(false)
        setFinalStep(true)
    }
    const handleCancel = () => {
        handleClose()
        setTriggerEdit(false)
        setFinalStep(true)
    }

    const CreateScheduler = async (payload) => {
        const actions = SchedulerActions(app());
        const [error, data] = await actions.CreateSchedulerBasedonTime(payload);
        if (!error) {
            console.log(data)
        }
    }

    const handleDraft = () => {
        setDraft(true)
    }

    const handleTimes = (times, id) => {
        if(times.length > 2) return;
        setFreqs(
            freqs.map((el) => {
                if (el.id === id) {
                    return { ...el, times: times }
                }
                else return el;
            })
        )
        
    }

    const handleDrp = (drp, id) => {
        setFreqs(
            freqs.map((el) => {
                if (el.id === id) {
                    return { ...el, drp: drp }
                }
                else return el;
            })
        )
    }

    const handleAddTrigger = () => {
        if (freqs[freqs.length - 1].times) {
            setFreqs(
                [...freqs, {
                    id: uuidv4(),
                    day: "1st",
                    drp: "hours",
                    hr: "",
                    isOpended: false,
                    min: "",
                    times: "",
                    week: "Monday"
                }]
            )

        }

        setCount((p) => p + 1);

    }

    const handleDeleteTrigger = (id) => {
        setFreqs(
            freqs.filter((el) => el.id !== id)
        )
    }

    const handleisOpended = (id , flag) => {
        setFreqs(
            freqs.map((el) => {
                if (el.id === id) {
                    return { ...el, isOpended: flag, hr: "", min: "" }; 
                }
                return el;
            })
        );
    };


    const handleHour = (hr, id) => {
           if(hr.length > 2) return;
        setFreqs(
            freqs.map((el) => {
                if (el.id === id) {
                    return { ...el, hr: hr }
                }
                else return el;
            })
        )
    }

    const handleMin = (min, id) => {
           if(min.length > 2) return;
        setFreqs(
            freqs.map((el) => {
                if (el.id === id) {
                    return { ...el, min: min }
                }
                else return el;
            })
        )
    }
    const handleWeek = (week, id) => {
        setFreqs(
            freqs.map((el) => {
                if (el.id === id) {
                    return { ...el, week: week }
                }
                else return el;
            })
        )
    }
    const handleDay = (day, id) => {
           if(day.length > 2) return;
        setFreqs(
            freqs.map((el) => {
                if (el.id === id) {
                    return { ...el, day: day }
                }
                else return el;
            })
        )
    }

    useEffect(() => {
        setFreq(freqs)
        setShowError(false);
    }, [freqs])
    
    return <>
        <PopUp popUp={show} setPopUp={handleClose} testId={"trigger-scheduler"} titleClassName={styles.triggerHeader} title={"When do you want to trigger it?"}>
            <Form>
                <div className={styles.formArea}>
                    <div className={styles.column}>
                        {
                            freqs.length ? freqs.map((el) => {
                                return <div key={el.id}>
                                    <div className={styles.triggerComp}>
                                        <label>Repeat every</label>
                                        <input className={styles.triggerCompInput} type="number"   value={el.times} defaultValue={0} onChange={(e) => handleTimes(e.target.value, el.id)} />
                                        <select className={styles.triggerCompSelect} style={{ backgroundColor: "transparent" }} value={el.drp} onChange={(e) => handleDrp(e.target.value, el.id)}>
                                            {
                                                time.map((el) => {
                                                    return <option key={el}>{el}</option>
                                                })
                                            }
                                        </select>
                                        {
                                            freqs.length > 1 ?
                                                <ClearIcon
                                                    fontSize="string"
                                                    className={styles.deleteTrigger}
                                                    onClick={() => handleDeleteTrigger(el.id)}
                                                /> : ""
                                        }


                                    </div>
                                    {/* days */}
                                    {
                                        el.drp === "days" && <div className={styles.triggerCompDays}>
                                            <label>at</label>
                                            {
                                                !el.isOpended ? <AddIcon fontSize="string"
                                                    className={styles.plusIcon} onClick={() => handleisOpended(el.id, true)} /> :
                                                    <>
                                                        <input className={styles.triggerCompInput}
                                                            type="number" placeholder="Hours" value={el.hr} onChange={(e) => handleHour(e.target.value, el.id)} />
                                                        <input className={styles.triggerCompInput}
                                                            type="number" placeholder="Minutes" value={el.min} onChange={(e) => handleMin(e.target.value, el.id)} />
                                                        <ClearIcon fontSize="string"
                                                            onClick={() => handleisOpended(el.id, false)}
                                                            className={styles.deleteTrigger} />
                                                    </>
                                            }


                                        </div>
                                    }


                                    {/* weeks */}
                                    {
                                        el.drp === "weeks" && <div>
                                            <div className={styles.triggerCompDays}>
                                                <label>on</label>
                                                <select className={styles.triggerCompSelect} style={{ backgroundColor: "transparent", marginLeft: "10px" }} value={el.week} onChange={(e) => handleWeek(e.target.value, el.id)}>
                                                    {
                                                        weeks.map((el) => {
                                                            return <option key={el}>{el}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            <div className={styles.triggerCompDays}>
                                                <label>at</label>
                                                {
                                                    !el.isOpended ? <AddIcon fontSize="string"
                                                        className={styles.plusIcon} onClick={() => handleisOpended(el.id, true)} /> :
                                                        <>
                                                            <input className={styles.triggerCompInput}
                                                                type="number" placeholder="Hours" value={el.hr} onChange={(e) => handleHour(e.target.value, el.id)} />
                                                            <input className={styles.triggerCompInput}
                                                                type="number" placeholder="Minutes" value={el.min} onChange={(e) => handleMin(e.target.value, el.id)} />
                                                            <ClearIcon fontSize="string"
                                                                onClick={() => handleisOpended(el.id, false)}
                                                                className={styles.deleteTrigger} />
                                                        </>
                                                }
                                            </div>
                                        </div>
                                    }


                                    {/* months */}
                                    {
                                        el.drp === "months" && <div>
                                            <div className={styles.triggerCompMonths}>
                                                <label style={{ margin: "0 8px" }}>on the</label>
                                               <select
                                                    className={styles.triggerCompSelect}
                                                    style={{ backgroundColor: "transparent", marginLeft: "10px" }}
                                                    value={el.day}
                                                    onChange={(e) => handleDay(e.target.value, el.id)}
                                                    >
                                                    {days.map((d) => (
                                                        <option key={d.id} value={d.value}>
                                                        {getDayLabel(d.value)}
                                                        </option>
                                                    ))}
                                                    </select>

                                            </div>
                                            <div className={styles.triggerCompDays}>
                                                <label>at</label>
                                                {
                                                    !el.isOpended ? <AddIcon fontSize="string"
                                                        className={styles.plusIcon} onClick={() => handleisOpended(el.id, true)} /> :
                                                        <>
                                                            <input className={styles.triggerCompInput}
                                                                type="number" placeholder="Hours" value={el.hr} onChange={(e) => handleHour(e.target.value, el.id)} />
                                                            <input className={styles.triggerCompInput}
                                                                type="number" placeholder="Minutes" value={el.min} onChange={(e) => handleMin(e.target.value, el.id)} />
                                                            <ClearIcon fontSize="string"
                                                                onClick={() => handleisOpended(el.id, false)}
                                                                className={styles.deleteTrigger} />
                                                        </>
                                                }
                                            </div>
                                        </div>
                                    }



                                </div>
                            }) : ""
                        }

                        {
                            freqs.length < 3 ? (<small className={styles.addTrigger}
                                onClick={handleAddTrigger}>Add another trigger</small>) :
                                <small className={styles.addTrigger} style={{ color: "gray" }}
                                >Add another trigger</small>
                        }
                       {showError && (
                        <small className={styles.error}>Please enter valid scheduler value</small>
                        )}



                    </div>
                </div>

                <div className={styles.afFooter}>
                    {
                        !triggerEdit ?
                            <>
                                <Input
                                    type="button"
                                    value={"Back"}
                                    className="secondary"
                                    onClick={handleBack}


                                />
                                <Input
                                    type="submit"
                                    value={"Save Draft"}
                                    className="secondary"
                                    onClick={handleDraft}

                                />
                                <Input type="submit" className="primary" value={"Next"} />
                            </> :
                            <>
                                <Input
                                    type="button"
                                    value={"Cancel"}
                                    className="secondary"
                                    onClick={handleCancel}
                                />
                                <Input type="submit" className="primary" value={"Save"} />
                            </>
                    }

                </div>
            </Form>
        </PopUp>
    </>
}